import { WorkspaceRoutes } from 'types/common';
import { CURRENT_PATH } from 'utils/constants';

import OrdersLayoutScene from './orders-layout-scene';
import useOrdersLayout from './use-orders-layout';

const OrdersLayout = () => {
  const {
    t,
    url,
    history,
    sidemenuOpen,
    setSidemenuOpen,
    properties,
    statusFetchOrderData,
    orderHasAccountingData,
    isOrderLoading,
    orderType,
    idTitleCompany,
    transactionType,
    currentUser
  } = useOrdersLayout();

  const handleViewChange = (view: WorkspaceRoutes, param = '') => {
    localStorage.setItem(CURRENT_PATH, JSON.stringify({ view, param }));
    history.push(param ? `${url}/${view}/${param}` : `${url}/${view}`);
  };

  return (
    <OrdersLayoutScene
      t={t}
      sidemenuOpen={sidemenuOpen}
      setSidemenuOpen={setSidemenuOpen}
      statusFetchOrderData={statusFetchOrderData}
      handleViewChange={handleViewChange}
      properties={properties}
      orderHasAccountingData={orderHasAccountingData}
      isOrderLoading={isOrderLoading}
      orderType={orderType}
      idTitleCompany={idTitleCompany}
      transactionType={transactionType}
      currentUser={currentUser}
    />
  );
};

export default OrdersLayout;
